import Vue from "vue";
import IdleVue from "idle-vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import VueI18n from "vue-i18n";

import store from "./store/store";
import App from "./App.vue";
import Vuelidate from "vuelidate";
import { Select, Option, Step, Steps, OptionGroup } from "element-ui";
import "vue-swatches/dist/vue-swatches.css";
// router setup
import router from './routes/router';
import VueClipboard from 'vue-clipboard2'
import VueLazyload from 'vue-lazyload'


import en from "./assets/lang/en";
import es from "./assets/lang/es";
// plugin setup
Vue.use(VueI18n);
Vue.use(DashboardPlugin);
Vue.use(Vuelidate);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Step);
Vue.use(Steps);
Vue.use(VueClipboard);

const eventsHub = new Vue();

const messages = {
  en,
  es
};

let clientLang =
  localStorage.getItem("iv-local-lang") ||
  window.navigator.language.split("-")[0];
let localLang = "en";

if (localLang in messages) {
  localLang = clientLang;
  localStorage.setItem("iv-local-lang", localLang);
} else {
  localStorage.setItem("iv-local-lang", localLang);
}

const i18n = new VueI18n({
  locale: localLang, // set locale
  messages // set locale messages
});

const loadimage = require("./assets/loading.gif");
const errorimage = require("./assets/error.png");

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1,
  lazyComponent: true,
  listenEvents: [
    "scroll",
    "wheel",
    "mousewheel",
    "resize",
    "animationend",
    "transitionend"
  ]
});

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 1 * (30 * (60 * 1000)) - 2 * (60 * 1000), // 3 seconds,
  startAtIdle: false
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  i18n
});
